
import axios from 'axios';

/**
 * Uploads a file to the server's dedicated upload endpoint.
 * @param file The file to upload.
 * @param onProgress A callback function to track upload progress (0-100).
 * @returns A promise that resolves with the secure URL of the uploaded file.
 */
export const uploadWorkFile = async (file: File, onProgress: (progress: number) => void): Promise<{ submittedWorkLink: string }> => {
  const formData = new FormData();
  formData.append('workFile', file);

  try {
    const response = await axios.post('/api/proposals/collab/upload-work', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      },
    });
    return response.data;
  } catch (error) {
    console.error("File upload failed:", error);
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || "Upload failed. Please try again.");
    }
    throw new Error("Upload failed. Please try again.");
  }
};
